<div id="faqs" class="faqs-section pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span>الأسئلة الشائعة</span>
            <h2>فيما يلي بعض الأسئلة الشائعة حول Trackid</h2>
            <p>
                لقد أجبنا على العديد من الاسئله حول Trackid من خلال صفحاتنا
                الاجتماعية ، وهذه هي الاسئلة الأكثر شيوعًا
            </p>
        </div>
        <div
            class="faqs-container row justify-content-center"
            *ngFor="let question of questions"
        >
            <div
                class="question col-lg-6 col-11"
                (click)="openQuestion($event)"
            >
                <div class="question_Head">
                    {{ question.question }}
                </div>
                <div class="question_answer">
                    {{ question.answer }}
                </div>
            </div>
        </div>
    </div>
</div>
